export const TERMS_AND_CONDITIONS = "https://handyday.com/allmanna-villkor";

// export const TERMS_AND_CONDITIONS = "https://organization-public-files-dev.s3.eu-north-1.amazonaws.com/terms/HandyDay+Terms+of+Use+2021-02-15.pdf";
